import styled, { css } from 'styled-components';
import { Rating } from "@progress/kendo-react-inputs";


const StyledRating = styled(Rating)`
.k-rating-container {
    margin: 0 !important;
}
.k-rating-item {
  ${({ theme }) => css`
  padding: 0rem !important;
  color: ${theme["color-positiveLightX"]} !important;
  `}
  &.k-selected {
    ${({ theme, dark, pinkColor }) => css`
      color: #a3fd0d !important;
      color: ${ dark && `${theme["smylor-blue-darken-D"]} !important`} ;
      color: ${ pinkColor && `${theme["smylor-pink"]} !important`} ;
      .k-i-dollar-outline{
        color: ${theme["thm-base-hover"]} !important;
      }
    `}
  }
  .k-rating-precision-complement {
    right: 0rem !important;
    top:0rem !important;
  }
  .k-rating-precision-part{

    left: 0rem !important;
    top:0rem !important;
  }

  .k-i-dollar-outline{
    color:#f1f1f1;
    &:before{
      content: "\\e694";
    }
  }
}
`;

export default StyledRating;